import { render, staticRenderFns } from "./login-social.vue?vue&type=template&id=5f2e2ddb&"
import script from "./login-social.vue?vue&type=script&lang=js&"
export * from "./login-social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports